import { ShieldCheck } from "lucide-react";

export default function Guarantee() {
  return (
    <section className="py-24 md:py-32 bg-brand-olive text-brand-bg relative overflow-hidden" data-testid="guarantee-section">
      <div className="absolute inset-0 grain-bg pointer-events-none opacity-50"></div>
      <div className="max-w-4xl mx-auto px-6 md:px-8 text-center relative">
        <div className="w-16 h-16 mx-auto rounded-full bg-brand-bg/10 border border-brand-bg/20 flex items-center justify-center mb-8">
          <ShieldCheck className="w-8 h-8 text-brand-bg" strokeWidth={1.5} />
        </div>
        <p className="text-xs font-medium tracking-[0.25em] uppercase text-brand-bg/70 mb-6">La garanzia</p>
        <h2 className="font-heading text-4xl md:text-6xl leading-[1.1]" data-testid="guarantee-text">
          Provala 30 giorni.<br />
          Se non funziona, ti rimborsiamo.<br />
          <span className="italic text-brand-bg/80">E ti ringraziamo per averla provata.</span>
        </h2>
      </div>
    </section>
  );
}
